module.exports = __webpack_public_path__ + "static/media/auto_awesome_filled.6c9c0280.svg";